export class RogTaskInfo {
    rogID: string;
    orderNumber: string;
    projectName: string;
    accountNumber: string;
    expectedCompletion: string;
    // receiptOfGoodsSkuList: RogSkuObject[];
    receiptOfGoodsSkus :RogSkuDetail [];
}

export class RogSkuObject {
    sku: string;
    problem: boolean;
    comments: string;
    status: string;
    quantity: number;
    imageIds: string[];
    partNumber: string;
    //Below address details are added as part of OASIS-1375
    addressToShipToLine1: string;
    addressToShipToLine2: string;
    addressToShipToCity: string;
    addressToShipToState: string;
    addressToShipToPostalCode: string;

    constructor() {
        this.sku = '';
        this.comments = '';
        this.status = '-';
        this.quantity = 0;
        this.imageIds = [];
        this.partNumber = '';
        this.addressToShipToLine1 = '';
        this.addressToShipToLine2 = '';
        this.addressToShipToCity = '';
        this.addressToShipToState = '';
        this.addressToShipToPostalCode = '';
    }
}

export class RogInput {
    receiptOfGoodsId: string;
    skusInReceipt: RogSkuObject[];

    constructor() {
        this.receiptOfGoodsId = '';
        this.skusInReceipt = [];
    }
}

export class RogDetailInput {
    accountNumber: string;
    orderNumber: string;
    receiptOfGoodsId: string;
    receiptOfGoodsSkus: RogSkuDetail[];
    constructor() {
      this.receiptOfGoodsId = '';
      this.receiptOfGoodsSkus = [];
  }
}

export class RogDetail {
    id: string;
    orderNumber: string;
    accountNumber: string;
    receiptOfGoodsSkus: RogSkuDetail[];
    expectedCompletion: string;
    rogProblemDetails: RogReportProblem[];
}

export class RogSkuDetail {
  id: string;
  sku: string;
  parentSku: string;
  index: number;
  mpn: string;
  deliveryQty: string;
  manufacturerName: string;
  orderQuantity: string;
  backorderQuantity: string;
  expectedShipDate: string;
  deliveryNumber: string;
  plannedShipDate: string;
  actualShipDate: string;
  trackingID: string;
  carrierID: string;
  podDate: string;
  comments: string;
  status: string;
  carrierName: string;
  carrierWebsite: string;
  podStatus: string;
  imageIds: string[];
  problemQty: number;
  description: string;

  //Below address details are added as part of OASIS-1375
  addressToShipToLine1: string;
  addressToShipToLine2: string;
  addressToShipToCity: string;
  addressToShipToState: string;
  addressToShipToPostalCode: string;

  //Below details are added as part of OASIS-3608
  damageOnBolNo:string;
  packagingDamaged:string;
  keepExcess:string;
  replacementDeliveryDate:string;
  reportedByFirstName:string;
  reportedByLastName:string;
  sameShipmentAddress:boolean;
  addressToShipFirstName:string;
  addressToShipLastName:string;
  addressToShipToPhone:string;
  addressToShipToEmail:string;
  addressToShipCompanyName:string;
  liftGateRequired:boolean;

  
}

export class RogRetract {
    siteName: string;
    status: string;
    marketName: string;
    orderNumber: string;
    sku: string;
    parentSku: string;
    partNumber: string;
    partDescription: string;
    quantity: number;
    retractionComment: string;
    rogId: string;
    projectName: string;
    accountNumber: string;
    receiptOfGoodsSkuId: string;

    constructor() {
        this.siteName = '';
        this.status = '';
        this.marketName = '';
        this.orderNumber = '';
        this.sku = '';
        this.partNumber = '';
        this.partDescription = '';
        this.quantity = 0;
        this.retractionComment = '';
        this.rogId = '';
        this.projectName = '';
        this.accountNumber = '';
        this.receiptOfGoodsSkuId = '';
        this.parentSku = '';
    }
}

export class RogReportProblem{
    rogId: string;
    rogSkuId: string;
    sku: string;
    comment: string;
    status: string;
    quantity: number;
    imageId: string;
}




// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/rog.ts